import React from 'react';
import { ModalProvider } from './modals';
import { NotificationsProvider } from './notifications';
import { UserProvider } from './user';

export const StoreProvider: React.FC = ({ children }) => (
  <UserProvider>
    <ModalProvider>
      <NotificationsProvider>
        {children}
      </NotificationsProvider>
    </ModalProvider>
  </UserProvider>
);
